import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AfterViewInit, Component, computed, ElementRef, inject, input, OnDestroy, OnInit, signal, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { faStar } from '@fortawesome/pro-solid-svg-icons';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { PreviewDevice, PreviewDevices, RatingType } from '@empathy/survey/base';
import { Question } from '@empathy/survey/base';

@Component({
  selector: 'empathy-rating-question-view',
  templateUrl: 'rating-question-view.component.html',
  styleUrls: ['./rating-question-view.component.scss', './_rating-question-view-theme.component.scss']
})
export class RatingQuestionViewComponent implements AfterViewInit, OnInit, OnDestroy {
  @ViewChild('starContainer', { static: false }) starContainer!: ElementRef;

  question = input<Question>();
  questionGrp = input<FormGroup>();

  visibleOptions$ = computed(() => this.question().visibleOptions);

  applyStarsContainerMaxWidth$ = signal<boolean>(false);
  isWeb$ = signal<boolean>(false);
  maxXStarsRatingScale$ = signal(5);

  readonly maxXRatingScale = 10;

  faStar = faStar;
  ratingType = RatingType;

  private destroyed = new Subject<void>();

  private webBreakpoints = [Breakpoints.Large, Breakpoints.XLarge];
  private readonly breakpoints = {
    xs: parseInt(Breakpoints.XSmall.match(/\d+/)?.[0] || '0', 10),
    sm: parseInt(Breakpoints.Small.match(/\d+/)?.[0] || '0', 10)
  };
  private resizeObserver!: ResizeObserver;
  private breakpointObserver = inject(BreakpointObserver);

  ngOnInit(): void {
    this.breakpointObserver
      .observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge])
      .pipe(takeUntil(this.destroyed))
      .subscribe((result) => {
        for (const queryPoint of Object.keys(result.breakpoints)) {
          if (result.breakpoints[queryPoint]) {
            this.isWeb$.set(this.webBreakpoints.includes(queryPoint));
          }
        }
      });
  }

  ngAfterViewInit(): void {
    this.resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const width = entry.contentRect.width;
        this.updateStars(width);
        this.applyStarsContainerMaxWidth$.set(width > this.breakpoints.sm);
      }
    });

    if (this.starContainer) {
      this.resizeObserver.observe(this.starContainer.nativeElement);
    }
  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  onRate(scale: number): void {
    this.questionGrp().get('value').setValue(scale);
  }

  onSelectDescriptive(optionId: string): void {
    this.questionGrp().get('value').setValue(optionId);
  }

  private updateStars(width: number): void {
    if (this.isWeb$()) {
      if (width < PreviewDevices[PreviewDevice.Phone].width) {
        this.maxXStarsRatingScale$.set(4);
        return;
      } else {
        this.maxXStarsRatingScale$.set(10);
      }

      return;
    }

    if (width < this.breakpoints.xs) {
      this.maxXStarsRatingScale$.set(5);
    } else {
      this.maxXStarsRatingScale$.set(10);
    }
  }
}
